import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
  tableActions: {
    display: 'flex',
    justifyContent: 'center'
  }
});
